import * as S from "./ModalPointStandard.style";
import { Buttons } from "@/components/atoms/Buttons";
import { ModalProps, Modals } from "..";
import { PointStandardContent } from "../../PointStandardContent";

interface ModalPointStandardProps extends ModalProps {}

export const ModalPointStandard = ({
  setModalShow,
}: ModalPointStandardProps) => {
  return (
    <Modals
      title="포인트 지급기준"
      setModalShow={setModalShow}
      modalButtons={
        <>
          <Buttons
            type="button"
            size="lg"
            layout="text"
            color="primary100"
            label="닫기"
            onClick={() => setModalShow(false)}
          />
        </>
      }
    >
      <S.ModalPointStandardBox>
        <PointStandardContent showMainBox={false} />
      </S.ModalPointStandardBox>
    </Modals>
  );
};
